import { useLazyQuery } from 'providers/tanstack-query/useLazyQuery'
import { downloadFile } from 'utils/file'
import { DOWNLOAD_TAGS } from './query'
import { Data, UseDownloadTags, UseDownloadTagsProps, Variables } from './types'

export const useDownloadTags = ({ id, name, tagKind }: UseDownloadTagsProps): UseDownloadTags => {
  const { lazyFetch } = useLazyQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { downloadTags: file } = data
      const blob = new Blob([file.data], { type: file.type })

      const filename: string = `${name} - ${tagKind}.txt`
      downloadFile(blob, filename)
    },
    query: DOWNLOAD_TAGS,
    variables: {
      domainId: id,
      tagsType: tagKind,
    },
  })

  return {
    lazyDownload: lazyFetch,
  }
}
